<template>
    <div class="page-container">
        <div class="page-header-container">
            <img class="page-header-container-img" src="../images/node.svg" alt="node">
            <div class="page-header-txt-container">
                <div class="page-header-container-txt">{{ localize('节点订阅系统') }}</div>
            </div>

        </div>
        <div class="referrer-container" v-if="referrerWalletAddress">
            {{ localize('推荐人：') }}{{ this.referrerWalletAddress }}
        </div>
        <template v-if="this.myWalletAddress && this.getReferLink">
            <div class="copy-refer-link no-select" @click="onCopyReferLink">
                <img class="copy-refer-link-icon" src="../images/link.svg" alt="copy refer link">
                <div class="copy-refer-link-txt">{{ localize('我的邀请链接（点击复制）') }}</div>
            </div>
        </template>

        <template v-if="!this.myWalletAddress">
            <div class="wallet-not-connect-notification no-select" @click="onCopyReferLink">
                {{ localize('没有连接钱包') }}
            </div>
        </template>

        <template v-for="(item) in this.getNodeList" :key="item.name">
            <div class="node-card-container">
                <img class="basic-node-icon" :src=item.iconSvg alt="basic node">
                <div class="node-label-txt-container">
                    <div class="node-label-txt">{{ localize(item.name) }}</div>
                </div>

                <div class="node-price-container">
                    <img class="usdt-icon" src="../images/usdt.svg" alt="usdt">
                    <div class="node-price-txt">{{ item.price }} USDT</div>
                </div>
                <div class="node-des-container">
                    <template v-for="(des) in item.des" :key="des">
                        <div class="node-des-item-wrapper">
                            <div class="dot"/>
                            <div class="node-des-item-txt">{{ localize(des) }}</div>
                        </div>
                    </template>
                </div>

                <div class="buy-node-btn" @click="onBuyNode(item)">{{ localize(item.btnTxt) }}</div>

            </div>
        </template>

    </div>
</template>
<script>
import {connectDirect, maskBscAddress, sendUsdt, isBscTxHashFormat} from '@/utils/web3Helper'
import {showToast} from '@/utils/toastHelper'
import {showLoading, hideLoading} from '@/utils/spinnerHelper'
import {postRequestAsync} from '@/utils/request'
import copy from 'copy-to-clipboard';

export default {
    name: 'PresalePage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {}
    },
    async mounted() {
    },
    computed: {
        getNodeList() {
            return this.$store.state.nodeList
        },
        myWalletAddress() {
            return this.$store.state.connectedWallet
        },
        getReferLink() {
            return this.$store.state.referLink
        },
        referrerWalletAddress() {
            if (!this.$store.state.referrerWalletAddress) {
                return null
            }
            return maskBscAddress(this.$store.state.referrerWalletAddress)
        }
    },
    methods: {
        onCopyReferLink() {
            copy(this.getReferLink)
            showToast(this.localize('复制成功'))
        },
        getReferId() {
            const params = new URL(window.location.href).searchParams
            return params.get('ref')
        },
        async onBuyNode(item) {
            if (!this.myWalletAddress) {
                showToast(this.localize('请连接钱包'))
                return
            }
            showLoading(this.localize('交易中'))
            try {
                const result = await postRequestAsync('payment/createNodeTransaction', {
                    purchaseWallet: this.myWalletAddress,
                    nodeType: item.type
                })
                if (result?.code === 203) {
                    showToast(this.localize('已购买'))
                    return
                }

                if (result?.code === 200 && result?.msg?.receiverWallet && result?.msg?.amount && result?.msg?.paymentId) {
                    const txResult = await sendUsdt({
                        from: this.myWalletAddress,
                        to: result?.msg?.receiverWallet,
                        amountStr: result?.msg?.amount
                    })
                    if (isBscTxHashFormat(txResult)) {
                        await postRequestAsync('payment/updateNodeTxHash', {
                            purchaseWallet: this.myWalletAddress,
                            paymentId: result?.msg?.paymentId,
                            tx: txResult
                        })
                        showToast(this.localize('转账已发起'))
                        return
                    }

                    if (txResult === -1) {
                        showToast(this.localize('USDT余额不足'))
                        return
                    }
                    if (txResult === -2) {
                        showToast(this.localize('转账被取消'))
                        return
                    }
                    if (txResult === -4) {
                        showToast(this.localize('未连接钱包'))
                        return
                    }
                }
            } catch (e) {

            } finally {
                hideLoading()
            }


        }
    }
}
</script>

<style scoped>

.page-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
}

.page-header-container-img {
    width: 2.4em;
}

.page-header-container-txt {
    font-size: 2em;
    color: #38FF59;
}

.page-header-container-txt-en{
    font-size: 1.4em;
    color: #38FF59;
}

.referrer-container {
    color: #FFE5DF;
    font-size: 1.6em;
    padding-top: 1em;
}

.copy-refer-link {
    display: flex;
    flex-direction: row;
    padding: 0.5em;
    margin-top: 1.6em;
    background-color: rgba(56, 255, 89, 0.4);
    border-radius: 0.4em;
    border: 1px solid #38FF59;
    cursor: pointer;
}

.copy-refer-link-icon {
    width: 1.6em;
    margin-right: 0.8em;
}

.copy-refer-link-txt {
    font-size: 1.6em;
    color: #38FF59;
}

.copy-refer-link:active {
    transform: scale(0.95);
}

.node-card-container {
    border: 2px solid #38FF59;               /* 必須先有邊框寬度 */
    border-radius: 0.8em;
    font-size: 1em;
    width: 100%;
    padding: 2em;
    box-sizing: border-box;
    margin-top: 4em;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3em;
    position: relative;
}


.basic-node-icon {
    width: 8em;
}

.node-label-txt-container{
    display: flex;
    flex-direction: column;
}

.node-label-txt {
    font-size: 2.2em;
    color: #FFE5DF;
}
.node-label-txt-en {
    font-size: 1.4em;
    color: #FFE5DF;
    box-sizing: border-box;
}

.node-price-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
}

.usdt-icon {
    width: 2em;
    margin-right: 0.8em;
}

.node-price-txt {
    color: #FFE5DF;
    font-size: 2em;
}

.node-des-container {
    font-size: 1em;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1em;
}

.node-des-item-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: start;
    font-size: 1em;
    gap: 1em;
}


.dot {
    flex: 0 0 auto; /* 不拉伸 */
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #38FF59;
    margin-top: 1em;
}

.node-des-item-txt {
    color: #38FF59; /* 颜色 */
    line-height: 1.6;
    font-size: 1.6em;
    word-break: break-word; /* 长词可换行 */
    white-space: normal;
    text-align: start;
}

.buy-node-btn {
    background: #13B42E;
    background: linear-gradient(90deg,rgba(19, 180, 46, 1) 0%, rgba(167, 190, 33, 1) 50%, rgba(177, 16, 117, 1) 100%);
    color: #ffffff;
    font-size: 1.6em;
    padding: 0.4em;
    box-sizing: border-box;
    border-radius: 0.3em;
    width: 100%;
    align-items: center;
    cursor: pointer;
}

.buy-node-btn:active {
    transform: scale(0.95);
}

.wallet-not-connect-notification {
    display: flex;
    flex-direction: row;
    padding: 0.5em;
    margin-top: 1.6em;
    border-radius: 0.4em;
    cursor: pointer;
    color: #e12200;
    font-size: 2em;
}

.page-header-txt-container{
    display: flex;
    flex-direction: column;
    padding: 0 1em;
    box-sizing: border-box;
}
</style>